import { useGetBuckets } from '@shadcn/hooks/use-storage';
import { Alert } from '~/components/ui/Alert';
import { Button } from '~/components/ui/Button';
import { LabelBadge } from '~/components/ui/LabelBadge';
import { Skeleton } from '~/components/ui/Skeleton';
import * as Tooltip from '~/components/ui/Tooltip';

export function StorageManager() {
  const { data: buckets, isLoading, isError } = useGetBuckets();

  return (
    <div className="p-6 pt-4 lg:p-8 lg:pt-8">
      <h1 className="text-base lg:text-xl font-semibold">Storage</h1>
      <p className="hidden lg:block text-sm lg:text-base text-bolt-ds-textSecondary mt-1">
        View and manage the files stored in your app.
      </p>

      {isLoading && (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      )}
      {isError && (
        <Alert type="danger" className="mt-8" title="Error loading buckets">
          There was a problem loading your storage buckets.
        </Alert>
      )}

      {buckets && buckets.length > 0 ? (
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {buckets.map((bucket: any) => (
            <Tooltip.Provider key={bucket.id}>
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <Button
                    key={bucket.id}
                    variant="secondary"
                    className="flex-row items-start justify-start text-left h-auto p-4 gap-4 cursor-default"
                    startIcon="i-lucide:folder size-4 text-bolt-ds-textSecondary"
                  >
                    <div className="flex flex-col gap-1">
                      <h2 className="font-semibold">{bucket.name}</h2>
                      <p className="text-xs text-bolt-ds-textSecondary">
                        Updated {new Date(bucket.updated_at).toLocaleDateString()}
                      </p>
                      <LabelBadge variant={bucket.public ? 'primary' : 'secondary'} className="mt-1 w-min">
                        {bucket.public ? 'Public' : 'Private'}
                      </LabelBadge>
                    </div>
                  </Button>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                  <Tooltip.Content side="bottom" align="center" sideOffset={4}>
                    <p>Viewing files is coming soon</p>
                  </Tooltip.Content>
                </Tooltip.Portal>
              </Tooltip.Root>
            </Tooltip.Provider>
          ))}
        </div>
      ) : buckets && buckets.length === 0 ? (
        <Alert className="mt-8" title="No storage buckets" type="info">
          A bucket is a container used to store and protect files in your app.
        </Alert>
      ) : null}
    </div>
  );
}
